import ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import { Observable } from "rxjs";
import { catchError, finalize, map, tap } from "rxjs/operators";
import { create } from "superstruct";
import { singleton } from "tsyringe";

import { LoggerInterface } from "@interfaces/LoggerInterface";

import InstagramStoriesEntity from "../../entities/InstagramStoryEntity";
import InstagramStoriesStore from "../../stores/InstagramStoriesStore";
import InstagramStoriesResponseSchema from "./schemas/InstagramStoriesResponseSchema";

@singleton()
export class InstagramStoriesService {
    constructor(
        private instagramStoriesStore: InstagramStoriesStore,
        private readonly apiClient: ApiClientInterface,
        private readonly logger: LoggerInterface
    ) {}
    getGalleryStories(reqParams: {
        galleryId: number;
        widgetId: number;
    }): Observable<InstagramStoriesEntity[]> {
        this.logger.debug(
            "InstagramStoriesService.getGalleryStories is started",
            {
                reqParams,
            }
        );
        this.instagramStoriesStore.setLoading(true);
        return this.apiClient
            .get({
                url: "/instagram/getGalleryStories",
                responseType: "json",
                queryParams: {
                    galleryId: reqParams.galleryId,
                    widgetId: reqParams.widgetId,
                },
            })
            .pipe(
                finalize(() => {
                    this.instagramStoriesStore.setLoading(false);
                }),
                map((v) => create(v.body, InstagramStoriesResponseSchema)),
                catchError((error: unknown) => {
                    this.logger.debug(
                        "InstagramStoriesService.getGalleryStories is errored",
                        reqParams
                    );
                    this.instagramStoriesStore.setError(true);
                    throw error;
                }),
                tap((v) => {
                    this.logger.debug(
                        "InstagramStoriesService.getGalleryStories is ready",
                        reqParams
                    );
                    if (v.length) this.instagramStoriesStore.add(v);
                })
            );
    }
}
export default InstagramStoriesService;
